module.exports = __webpack_public_path__ + "static/img/name7.82bf375.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/name7.png
// module id = xr5D
// module chunks = 1